<template>
  <div>
    <div class="">
      <HeaderOfPage :titleOfPage="'عنوان البلوج'" :bgSrc="'banner-single-blog.jpg'"/>
    </div>
    <section class="pages-container">
      <b-container>
        <div class="single-blog-container">
          <article>
            <figure>
              <img src="images/banners/banner-single-blog.jpg" alt="blog-img" title="title of blog"/>
              <figcaption>
                نصائح تفيدك اذا كنت من هواة تسلق الجبال
              </figcaption>
            </figure>
            <h1>نصائح تفيدك اذا كنت من هواة تسلق الجبال</h1>

            <p>
              إستخدم دليلاً - إنّ محترفاً مخضرماً سوف يمهّد الطريق أمامك ويمكنه استئجار العتاد الذي ستحتاج إليه.
              اللياقة العالية ضرورية - عليك بزيارة الصالة الرياضية بشكل منتظم.
              إبتع أفضل ما يتوافر من عتاد - لأنّ سترة تزلج قديمة مع بنطلون جينز لا ينفعان هنا!!
            </p>
          </article>

          <div class="social-media-container">
            <social-sharing :url="'http://localhost:8080/#/blog/' + 'progname'"
                                 title="اليونان صيف 2020"
                                 description=""
                                 quote=""
                                 hashtags="اليونان"
                                 twitter-user=""
                                 inline-template>
             <div>
                 <network network="email" class="email">
                     <i class="far fa-envelope"></i>

                 </network>

                 <network network="facebook" class="facebook">
                   <i class="fab fa-facebook-square"></i>
                 </network>

                 <network network="linkedin" class="linkedin">
                   <i class="fab fa-linkedin"></i>
                 </network>

                 <network network="pinterest" class="pinterest">
                   <i class="fab fa-pinterest-square"></i>
                 </network>

                 <network network="sms">
                   <i class="fas fa-sms"></i>
                 </network>

                 <network network="twitter" class="twitter">
                   <i class="fab fa-twitter-square"></i>
                 </network>
                 <network network="whatsapp" class="whatsapp">
                   <i class="fab fa-whatsapp-square"></i>
                 </network>
             </div>
           </social-sharing>
       </div>
        </div>
      </b-container>
    </section>
  </div>
</template>
<script type="text/javascript">

  import HeaderOfPage from '../global/HeaderOfPage'

  import Vue from 'vue'
  var SocialSharing = require('vue-social-sharing');
  Vue.use(SocialSharing);
  export default {
    name:'SingleBlog',
    components: {
      HeaderOfPage,

    }
  }
</script>
